import { ExpensesPaymentDetailsMethod } from "@/interfaces/expenses";
import { z } from "zod";

const OrderPaymentDetailsSchema = z.object({
  method: z.nativeEnum(ExpensesPaymentDetailsMethod),
  paymentDate: z.date(),
  amount: z.number(),
});

// Order Input Schema
export const schema = z.object({
  name: z.string().min(1, "Nome é obrigatório"),
  tags: z.array(z.string()).optional(),
  expenseDate: z.date(),
  paymentDetails: z.array(OrderPaymentDetailsSchema).optional(),
});
